// extracted by mini-css-extract-plugin
module.exports = {"root":"ProviderSocialLinksMobile_root___KPUx"};